import { locale, t } from '@/lib/i18n';

const DAYS = 30;

function lastDays(n: number): string[] {
  const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Belgrade' });
  return Array.from({ length: n }, (_, i) => fmt.format(new Date(Date.now() - (n - 1 - i) * 86400_000)));
}

/** Daily counts for the last 30 days (days without data shown as zero). No chart library needed. */
export function DailyBars({ data }: { data: Array<{ day: string; count: number }> }) {
  const counts = new Map(data.map((d) => [d.day, d.count]));
  const days = lastDays(DAYS).map((day) => ({ day, count: counts.get(day) ?? 0 }));
  const total = days.reduce((sum, d) => sum + d.count, 0);
  const max = Math.max(1, ...days.map((d) => d.count));
  const label = (day: string) =>
    new Date(`${day}T12:00:00`).toLocaleDateString(locale, { day: 'numeric', month: 'short' });
  return (
    <div>
      <div className="mb-2 flex items-baseline justify-between text-sm">
        <span className="text-slate-500">{t('Last {n} days', { n: DAYS })}</span>
        <span className="font-semibold">{t('{n} total', { n: total.toLocaleString(locale) })}</span>
      </div>
      <div className="flex h-36 items-end gap-1 border-b border-slate-200">
        {days.map((d) => (
          <div key={d.day} className="group relative flex h-full flex-1 flex-col justify-end">
            <div
              className={`rounded-t ${d.count ? 'bg-brand-600/80 group-hover:bg-brand-700' : 'bg-slate-100'}`}
              style={{ height: d.count ? `${Math.max(4, (d.count / max) * 100)}%` : '2px' }}
            />
            <div className="pointer-events-none absolute -top-7 left-1/2 z-10 hidden -translate-x-1/2 rounded bg-slate-900 px-1.5 py-0.5 text-[11px] whitespace-nowrap text-white group-hover:block">
              {label(d.day)}: {d.count}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-1 flex justify-between text-[11px] text-slate-400">
        <span>{label(days[0]!.day)}</span>
        <span>{label(days[Math.floor(DAYS / 2)]!.day)}</span>
        <span>{t('Today')}</span>
      </div>
    </div>
  );
}
